var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8473 1.16666C13.0313 1.16666 13.1995 1.27052 13.2819 1.43499C13.3541 1.57915 13.3496 1.7482 13.2733 1.88697L13.2362 1.94443L8.66675 8.16666V11.6667L7.59731 12.6389C7.42913 12.7653 7.22437 12.8336 7.01397 12.8333L6.85773 12.8302C6.47441 12.8155 6.35134 12.7388 6.33522 12.3305L6.33342 12.25V8.16666L1.76397 1.94443C1.6535 1.79713 1.63573 1.60006 1.71807 1.43537C1.79012 1.29127 1.928 1.19361 2.08469 1.17145L2.15286 1.16666H12.8473ZM4.10696 2.13888H3.62084C3.52878 2.13888 3.44462 2.1909 3.40345 2.27324C3.37051 2.33912 3.36961 2.41535 3.39885 2.48092L3.4264 2.52777L5.82584 5.68749C5.88862 5.77119 5.9979 5.80533 6.09715 5.77224C6.18222 5.74389 6.24356 5.6716 6.25935 5.58564L6.26334 5.54166V4.93402C6.26334 4.89896 6.25576 4.86453 6.24136 4.83301L6.21473 4.78819L4.29994 2.23611C4.26347 2.18747 4.21047 2.15472 4.15183 2.14333L4.10696 2.13888Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter1);
export default __webpack_public_path__ + "static/media/filter-1.126c760d.svg";
export { ForwardRef as ReactComponent };